import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class SupplierDetailsOnboardService {

  static getSupplymaterials(cId) {
    return HttpUtil.get(API_ROUTES.SUPPLIERDETAILSONBOARD.SUPPLYMATERIALSLIST+`${cId}/supply-materials?key`);
  }
  static onboardSupplierDetails(supplierDetailsId,params) {
    return HttpUtil.put(API_ROUTES.SUPPLIERDETAILSONBOARD.ONBOARD+`${supplierDetailsId}`,params);
  }
 
}
